import { render, staticRenderFns } from "./ListSoftwaresByClientSection.vue?vue&type=template&id=5459bf00&"
import script from "./ListSoftwaresByClientSection.vue?vue&type=script&lang=js&"
export * from "./ListSoftwaresByClientSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports